// These are all required for React v16
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/symbol';
import 'raf/polyfill';


// Polyfill string.includes() for IE...
/*eslint no-extend-native: "off"*/
if (!String.prototype.includes) {
  String.prototype.includes = function() {
    return String.prototype.indexOf.apply(this, arguments) !== -1;
  };
}

// Polyfill String .startsWith()
/*eslint no-extend-native: "off"*/
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}








// WEBPACK FOOTER //
// ./src/polyfills.js